module.exports = __webpack_public_path__ + "static/img/242_TO8_2182_og.7fa295f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/242_TO8_2182_og.jpg
// module id = n5Yz
// module chunks = 0